import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { DateTime } from 'src_common/utils/time/time';
import { TableSportsRowItem } from 'src/domains/sportsbook/webview/components/meetings/tableSports/TableSportsRowItem';
import {
    TableSportsWrapper,
    TableSportItems,
} from 'src/domains/sportsbook/webview/components/meetings/tableSports/TableSports.style';
import { TableSportsState } from 'src/domains/sportsbook/webview/components/meetings/tableSports/TableSports.state';
import { TableSportsSectionType } from 'src/domains/sportsbook/webview/components/meetingsAntePostAndSpecials/MeetingsGroup';
import { Collapse } from 'src/ui/components/collapse/sports/04/Collapse';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface MeetingsGroupInnerPropType {
    dataTest?: string;
    events: Record<string, EventModel[]>;
    handleScroll?: () => void;
    month: string;
    section: TableSportsSectionType;
}

export const TableSports = observer('TableSports', (props: MeetingsGroupInnerPropType) => {
    const { dataTest, events, handleScroll, month, section } = props;
    const getEvents = events[month] ?? [];

    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    const [state] = useState(() => new TableSportsState());
    const headerLabel = DateTime.from(month)?.format('MMMM') ?? '-';

    const columns = getEvents.length > 1 ? 2 : 1;

    return (
        <TableSportsWrapper
            data-test={dataTest ?? 'table-sports-wrapper'}
            variant={configState.componentVariants.sportsbookVariant}
        >
            <Collapse
                isOpen={state.isOpen}
                handleToggle={state.handleClick}
                title={headerLabel}
            />

            <TableSportItems
                isOpen={state.isOpen}
                variant={configState.componentVariants.sportsbookVariant}
                columns={columns}
            >
                {getEvents.map((event) => (
                    <TableSportsRowItem
                        eventId={event.id2}
                        sport={event.sport}
                        timeSettingsStartTime={event.timeSettingsStartTime}
                        key={event.id}
                        name={event.name}
                        section={section}
                        handleScroll={handleScroll}
                    />
                ))}
            </TableSportItems>
        </TableSportsWrapper>
    );
});
